import TokenSuccess from '../../../assets/svg/largeSVGImages/success.svg';
import TokenExpired from '../../../assets/svg/largeSVGImages/tokenExpired.svg';
import TokenFailed from '../../../assets/svg/largeSVGImages/tokenFailed.svg';
import {ReactComponent as TokenHeader} from '../../../assets/svg/tokenHeader.svg';
import i18n from '../../../i18n';
import './TokenVerificationTemplate.css';

import React from 'react';

const TokenVerificationTemplate = (props) => {
  const [content, setContent] = React.useState({
    icon: <img className="svgAsUrl" src={TokenFailed} alt="logo" />,
    heading: i18n.t('EMAIL_VERIFICATION_LINK_FAILED'),
    body: i18n.t('EMAIL_VERIFICATION_LINK_FAILED_DESC'),
  });

  const handleContent = () => {
    if (props.tokenVerified == 'success' && props.firstTimeLogin) {
      setContent({
        icon: <img className="svgAsUrl" src={TokenSuccess} alt="logo" />,
        heading: i18n.t('EMAIL_IS_VERIFIED'),
        body: i18n.t('EMAIL_IS_VERIFIED_BODY'),
      });
    } else if (props.tokenVerified == 'expired') {
      setContent({
        icon: <img className="svgAsUrl" src={TokenExpired} alt="logo" />,
        heading: i18n.t('EMAIL_VERIFICATION_LINK_EXPIRED'),
        body: i18n.t('EMAIL_VERIFICATION_LINK_EXPIRED_DESC'),
      });
    } else {
      setContent({
        icon: <img className="svgAsUrl" src={TokenFailed} alt="logo" />,
        heading: i18n.t('EMAIL_VERIFICATION_LINK_FAILED'),
        body: i18n.t('EMAIL_VERIFICATION_LINK_FAILED_DESC'),
      });
    }
  };
  React.useEffect(() => {
    handleContent();
  }, []);

  return (
    <div className="templateMain">
      <div className="templateContainer">
        <div className="templateLogo">
          <div className="svg">
            <TokenHeader />
          </div>
        </div>
        <div className="template-wrapper">
          <div className="svg">{content.icon}</div>
          <h5 className="template-heading">{content.heading}</h5>
          <p className="bodyTemplate">{content.body}</p>
          <div className="questionsLink">
            {i18n.t('DO_YOU_HAVE_QUESTIONS')}
            <br />
            <a href="">johndeerefinancial@customercare.com</a>
          </div>
          <div className="templateFooter">
            John Deere Finance India Pvt. Limited.
            <br /> &copy; 2023 MyFinancial All right reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenVerificationTemplate;
